"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const flex_js_1 = require("./flex.js");
const spinner_props_js_1 = require("./spinner.props.js");
const index_js_1 = require("../helpers/index.js");
const visually_hidden_js_1 = require("./visually-hidden.js");
const Spinner = React.forwardRef((props, forwardedRef) => {
    const { className, children, loading, ...spinnerProps } = (0, index_js_1.extractProps)(props, spinner_props_js_1.spinnerPropDefs, index_js_1.marginPropDefs);
    if (!loading)
        return React.createElement(React.Fragment, null, children);
    const spinner = (React.createElement("span", { ...spinnerProps, ref: forwardedRef, className: (0, classnames_1.default)('rt-Spinner', className) },
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" }),
        React.createElement("span", { className: "rt-SpinnerLeaf" })));
    if (children === undefined)
        return spinner;
    return (React.createElement(flex_js_1.Flex, { asChild: true, position: "relative", align: "center", justify: "center" },
        React.createElement("span", null,
            React.createElement("span", { style: { display: 'contents', visibility: 'hidden' } }, children),
            React.createElement(visually_hidden_js_1.VisuallyHidden, null, children),
            React.createElement(flex_js_1.Flex, { asChild: true, align: "center", justify: "center", position: "absolute", inset: "0" },
                React.createElement("span", null, spinner)))));
});
exports.Spinner = Spinner;
Spinner.displayName = 'Spinner';
//# sourceMappingURL=spinner.js.map